module.exports = __webpack_public_path__ + "img/pro-p-slider7.f0e3b9d3.png";